import formatISO from 'date-fns/formatISO';

import createDate from './createDate';
import { fixDatestamp } from './datestamp';
import parseStringTimestamp from './parseStringTimestamp';

export function formatDateForFilter(input: string | number) {
  return formatISO(fixDatestamp(createDate(parseStringTimestamp(input))), { representation: 'date' });
}
